import { Button } from "@mui/material";
import styled from "styled-components";

import { MOBILE_BREAKPOINT } from "@ryde/theme";

export const ContinueButtonStyled = styled(Button)`
  background-color: #3b0073;
  border-radius: 8px;
  text-transform: none;
  font-size: 16px;
  min-width: 120px;
  color: #fff;
  margin: 10px 0px;
  width: 260px;
  height: 50px;

  .button-content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: relative;
  }

  .button-label {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    font-weight: 600;
  }

  .button-icon {
    margin-inline-start: auto;

    &.isRtl {
      transform: rotate(180deg);
    }
  }

  &:hover {
    background-color: #2a0059;
  }

  &.Mui-disabled {
    background-color: #ccc;
    color: #666;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 250px;
    height: 50px;
    padding: 15px;
  }
`;
